<script setup lang="ts">
import { ref } from 'vue';
import MenuItemForm from './MenuItemForm.vue';
import BaseModal from '@/components/common/BaseModal.vue';
import type { MenuItem } from '@/types/menu';

interface Props {
  show: boolean;
  currentItem: MenuItem | null;
  formLoading: boolean;
  formErrors: Record<string, string>;
}

interface Emits {
  (e: 'close'): void;
  (e: 'submit', formData: Omit<MenuItem, 'id'>): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const formRef = ref();

function handleSubmit() {
  // Trigger form submission
  if (formRef.value) {
    formRef.value.handleSubmit();
  }
}

function handleFormSubmit(formData: Omit<MenuItem, 'id'>) {
  emit('submit', formData);
}

function handleClose() {
  emit('close');
}
</script>

<template>
  <BaseModal
    :show="show"
    :title="currentItem ? 'Editar Item' : 'Nuevo Item'"
    :show-close-button="true"
    :show-actions="true"
    :is-editing="currentItem !== null"
    :loading="formLoading"
    @close="handleClose"
    @save="handleSubmit"
  >
    <MenuItemForm
      ref="formRef"
      :menu-item="currentItem || undefined"
      :loading="formLoading"
      :errors="formErrors"
      :is-editing="currentItem !== null"
      @submit="handleFormSubmit"
      @cancel="handleClose"
    />
  </BaseModal>
</template>
